export default __webpack_public_path__ + "static/media/get-more-details.be6b22ce.jpg";